module.exports = require('./helpers/bundle-url').getBundleURL('4vDYv') + "icons.7bb96926.svg";